<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Produtos
					</h1>
				</div>
				<div>
					<router-link 
		                class="btn btn-success ml-2"
		                v-bind:to="{ name: 'produtoCategorias' }">
		                Categorias
		            </router-link>
					<button 
						class="btn btn-primary ml-2"
						@click="create()">
						Novo
					</button>
				</div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <produto-table 
		            	@show="show"
		            	:key="produto_key"
		            ></produto-table>
		        </div>
		    </div>
		</div>
		<!-- Cadastro de produtos -->
		<produto-create 
			@reload="reload">
		</produto-create>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				produto_key: 0
			}
		},
		methods: {
			create(){
				$('#create_produto').modal('show');
			},
			show(dado_id){
				this.$router.push('/adm/produtos/show/'+dado_id)
			},
			reload(){
				this.produto_key += 1;
			}
		}
	}
</script>